<!-- results-table.component.html -->
<h1 mat-dialog-title>
    <strong>{{ action | translate }}</strong> representante
    <span *ngIf="action == 'Delete'"> {{ LOCAL_DATA.nombre }}</span>
</h1>
<div mat-dialog-content>
    <ng-template *ngIf="action === 'Delete'">
        Seguro quiere eliminar al representante
        <b>{{ LOCAL_DATA.correoElectronico }}</b
        >?
    </ng-template>

    <div fxLayout="column">
        <div fxLayout="row">
            <mat-form-field
                *ngIf="action != 'Delete' && action != 'Reset'"
                class="select-medio"
                fxFlex="100"
            >
                <input
                    placeholder="Nombre"
                    matInput
                    [(ngModel)]="LOCAL_DATA.nombre"
                    [required]="true"
                    [disabled]="action == 'View'"
                />
            </mat-form-field>
            <mat-form-field
                *ngIf="action != 'Delete' && action != 'Reset'"
                class="select-medio"
                fxFlex="100"
            >
                <input
                    placeholder="Segundo nombre"
                    matInput
                    [(ngModel)]="LOCAL_DATA.segundoNombre"
                    [disabled]="action == 'View'"
                />
            </mat-form-field>
        </div>

        <div fxLayout="row">
            <mat-form-field
                *ngIf="action != 'Delete' && action != 'Reset'"
                class="select-medio"
                fxFlex="100"
            >
                <input
                    placeholder="Apellido"
                    matInput
                    [(ngModel)]="LOCAL_DATA.apellido"
                    [required]="true"
                    [disabled]="action == 'View'"
                />
            </mat-form-field>
            <mat-form-field
                *ngIf="action != 'Delete' && action != 'Reset'"
                class="select-medio"
                fxFlex="100"
            >
                <input
                    placeholder="Segundo apellido"
                    matInput
                    [(ngModel)]="LOCAL_DATA.segundoApellido"
                    [disabled]="action == 'View'"
                />
            </mat-form-field>
        </div>

        <fieldset *ngIf="action != 'Delete'">
            <legend>Datos de contacto</legend>
            <div fxLayout="column">
                <div fxLayout="row">
                    <mat-form-field
                        *ngIf="action != 'Delete' && action != 'Reset'"
                        class="select-full"
                        fxFlex="100"
                    >
                        <input
                            placeholder="Correo electrónico"
                            matInput
                            [(ngModel)]="LOCAL_DATA.correoElectronico"
                            [required]="true"
                            [disabled]="action == 'View'"
                        />
                    </mat-form-field>
                </div>
                <div fxLayout="row">
                    <mat-form-field
                        *ngIf="action != 'Delete' && action != 'Reset'"
                        class="select-full"
                        fxFlex="100"
                    >
                        <input
                            placeholder="Teléfono"
                            matInput
                            [(ngModel)]="
                                LOCAL_DATA.contacto.telefonos[0].numero
                            "
                            [disabled]="action == 'View'"
                        />
                    </mat-form-field>
                    <mat-form-field
                        *ngIf="action != 'Delete' && action != 'Reset'"
                        class="select-full"
                        fxFlex="100"
                    >
                        <input
                            placeholder="Interno"
                            matInput
                            [(ngModel)]="
                                LOCAL_DATA.contacto.telefonos[0].interno
                            "
                            [disabled]="action == 'View'"
                        />
                    </mat-form-field>
                </div>
            </div>
        </fieldset>

        <fieldset *ngIf="action != 'Delete'">
            <legend>Documento de identificación</legend>
            <div fxLayout="column">
                <div fxLayout="row">
                    <mat-form-field
                        *ngIf="action != 'Delete'"
                        class="select-list"
                        fxFlex="100"
                    >
                        <mat-label>Tipo de documento</mat-label>
                        <mat-select
                            [(ngModel)]="LOCAL_DATA.documentoIdentidad.tipo"
                            class="roleSelect"
                            [disabled]="action == 'View'"
                            [compareWith]="compareObjects"
                        >
                            <ng-container *ngFor="let tipo of tiposDocumentos">
                                <mat-option [value]="tipo">
                                    {{ tipo.nombre }}
                                </mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field
                        *ngIf="action != 'Delete' && action != 'Reset'"
                        fxFlex="100"
                    >
                        <input
                            placeholder="Número de documento"
                            matInput
                            [(ngModel)]="LOCAL_DATA.documentoIdentidad.numero"
                            [disabled]="action == 'View'"
                        />
                    </mat-form-field>
                </div>
                <div fxLayout="row">
                    <div fxFlex="100">
                        <mat-form-field color="accent" appearance="fill">
                            <mat-label>Fecha de emisión</mat-label>
                            <input
                                matInput
                                [matDatepicker]="picker1"
                                [(ngModel)]="
                                    LOCAL_DATA.documentoIdentidad
                                        .fechaExpedicion
                                "
                                [disabled]="action == 'View'"
                            />
                            <mat-datepicker-toggle
                                matSuffix
                                [for]="picker1"
                            ></mat-datepicker-toggle>
                            <mat-datepicker #picker1></mat-datepicker>
                        </mat-form-field>
                    </div>

                    <div fxFlex="100">
                        <mat-form-field color="accent" appearance="fill">
                            <mat-label>Fecha de expiración</mat-label>
                            <input
                                matInput
                                [matDatepicker]="picker2"
                                [(ngModel)]="
                                    LOCAL_DATA.documentoIdentidad
                                        .fechaVencimiento
                                "
                                [disabled]="action == 'View'"
                            />
                            <mat-datepicker-toggle
                                matSuffix
                                [for]="picker2"
                            ></mat-datepicker-toggle>
                            <mat-datepicker #picker2></mat-datepicker>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </fieldset>
    </div>
</div>

<div mat-dialog-actions>
    <button
        mat-button
        (click)="doAction()"
        *ngIf="action != 'View'"
        [disabled]="
            LOCAL_DATA.nombre.length < 1 || LOCAL_DATA.apellido.length < 1
            || LOCAL_DATA.correoElectronico.length < 1
        "
    >
        {{ action | translate }}
    </button>
    <button mat-button (click)="closeDialog()" mat-flat-button color="warn">
        {{ "Cancel" | translate }}
    </button>
</div>
